import React from 'react';
import type { Control, Path } from 'react-hook-form';
import { useIntl } from 'react-intl';

import type { VehicleCreateForm } from '@/modules/car/model/car-form';
import { useLicensingAuthorityTypes } from '@/shared/hooks/useLicensingAuthorityTypes';
import { SelectField } from '@src-common/view/adapters/reactHookForm/SelectField';
import { TextField } from '@src-common/view/adapters/reactHookForm/TextField';

import { messages } from './messages';

type TLicensingFormValues = Pick<VehicleCreateForm, 'licensingAuthority' | 'licenseNumber'>;

interface IProps<TForm extends TLicensingFormValues> {
  control: Control<TForm>;
}

const LicensingAuthorityField = <TForm extends TLicensingFormValues>({
  control,
}: IProps<TForm>) => {
  const intl = useIntl();
  const licensingAuthorityTypes = useLicensingAuthorityTypes();

  return (
    <SelectField
      control={control}
      name={'licensingAuthority' as Path<TForm>}
      title={intl.formatMessage(messages.licensingAuthorityTitle)}
      description={intl.formatMessage(messages.licensingAuthorityDescription)}
      items={licensingAuthorityTypes}
      isRequired={true}
    />
  );
};

const PHVField = <TForm extends TLicensingFormValues>({ control }: IProps<TForm>) => {
  const intl = useIntl();

  return (
    <TextField
      control={control}
      name={'licenseNumber' as Path<TForm>}
      title={intl.formatMessage(messages.phvTitle)}
      placeholder="12345678"
      description={intl.formatMessage(messages.phvDescription)}
      isRequired={true}
      rules={{
        pattern: {
          value: /^([a-z0-9]+)$/i,
          message: intl.formatMessage(messages.phvInvalid),
        },
      }}
    />
  );
};

export type { TLicensingFormValues };
export { LicensingAuthorityField, PHVField };
